import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { IDriver } from "@interfaces/IDriver";
import { DriverService } from "@services/driver.service";
import "./driver-name.component.scss";

@Component({
    selector: "driver-name",
    template: require("./driver-name.component.html")
})
export class DriverNameComponent implements OnChanges {
    @Input() id: number;
    @Input() driver: IDriver;

    constructor(private readonly driverService: DriverService) {
    }

    ngOnInit(): void {
        this.getDriver();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['id']) {
            this.getDriver();
        }

    }

    //--

    private getDriver(): void {
        if (!this.id) {
            return;
        }

        this.driver = this.driverService.getCachedDriver(this.id);

        if (!this.driver) {
            this.driverService.getDrivers().then(drivers => {
                this.driver = drivers.find(d => d.Id == this.id);
            });
        }

    }
}
